import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router';

import { modelOf } from '../../../prop-types';
import CustomerUserStore from '../../../store/CustomerUserStore';
import PurchaseReportForm from '../PurchaseReportForm';
import RequestState from '../../../types/RequestState';
import ContentForState from '../../loader/ContentForState';
import PurchaseList from '../PurchaseList';
import { paramsToQueryIdentifier } from '../../../util/query';

@observer
export class MainPurchaseList extends Component {
  state = {
    searchParams: {
      startDate: null,
      endDate: null
    }
  };

  getQueryParameters = () => {
    const { startDate, endDate } = this.state.searchParams;

    return startDate && endDate ? this.state.searchParams : null;
  };

  getQueryIdentifier = () => {
    return paramsToQueryIdentifier(this.getQueryParameters());
  };

  handleSubmit = (searchParams) => {
    const { customerUserStore } = this.props;

    this.setState({
      searchParams: searchParams
    });

    customerUserStore.loadPurchases(searchParams);
  };

  renderPurchaseForm = () => {
    const { customerUserStore } = this.props;

    return (
      <PurchaseReportForm
        onSubmit={this.handleSubmit}
        disableSubmit={
          customerUserStore.purchaseQueryStates.get(
            this.getQueryIdentifier()
          ) === RequestState.LOADING
        }
      />
    );
  };

  render() {
    const { customerUserStore } = this.props;

    return (
      <div className="MainPurchaseList">
        {this.renderPurchaseForm()}
        <ContentForState
          state={customerUserStore.purchaseQueryStates.get(
            this.getQueryIdentifier()
          )}
          forLoaded={() => (
            <PurchaseList searchParams={this.getQueryParameters()} />
          )}
        />
      </div>
    );
  }
}

MainPurchaseList.propTypes = {
  customerUserStore: modelOf(CustomerUserStore).isRequired
};

export default withRouter(inject('customerUserStore')(MainPurchaseList));



// WEBPACK FOOTER //
// ./src/components/purchase/MainPurchaseList/index.jsx